import { Medical } from "@/clients/models/Medical";
import { MedicalService } from "@/clients/services/MedicalService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetMedical = () => {
  const {
    data: medical,
    isLoading,
    isError,
    error,
  } = useQuery<Medical>({
    queryKey: [QueryKeys.MEDICAL],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await MedicalService.getMedicalInfoApiV1MedicalGet(
        user.id,
      );

      return data;
    },
  });

  return { medical, isLoading, isError, error };
};
